import {
  VIEW_VEHICLE_CATALOG,
  VIEW_VEHICLE,
  EDIT_VEHICLE,
  VEHICLES_MODULE,
  CREATE_VEHICLE_MANUAL,
  CREATE_VEHICLE_BATCH,
} from 'utils/roles/permissions';
import {
  VEHICLE_VIEW_CATALOG_PATH,
  VEHICLE_HISTORIC_DETAIL_PATH,
  VEHICLE_MANUAL_ADD_PATH,
  VEHICLE_MANUAL_DETAIL_PATH,
  VEHICLE_MANUAL_EDIT_PATH,
  VEHICLE_MASSIVE_LOAD_PATH,
  VEHICLE_MASSIVE_LOAD_FOR_SALES_PATH,
  VEHICLE_MASSIVE_CHANGE_PATH,
} from 'utils/roles/paths';

export function vehiclesAuth(permissions) {
  const allowedModules = [];

  const vehicleModule = permissions.filter((permission) =>
    permission.includes(VIEW_VEHICLE_CATALOG)
  );

  if (vehicleModule.length > 0) {
    allowedModules.push(VEHICLES_MODULE);
  }

  return allowedModules;
}

export function vehiclesPathsAuth(permissions) {
  const allowedPaths = [];

    allowedPaths.push(VEHICLE_MANUAL_ADD_PATH);



    allowedPaths.push(VEHICLE_MASSIVE_LOAD_PATH);
    allowedPaths.push(VEHICLE_MASSIVE_LOAD_FOR_SALES_PATH);
    allowedPaths.push(VEHICLE_MASSIVE_CHANGE_PATH);



    allowedPaths.push(VEHICLE_MANUAL_DETAIL_PATH);
    allowedPaths.push(VEHICLE_VIEW_CATALOG_PATH);
    allowedPaths.push(VEHICLE_HISTORIC_DETAIL_PATH);


    allowedPaths.push(VEHICLE_MANUAL_EDIT_PATH);

  return allowedPaths;
}
